import React from "react";
import ThirdPartyServiceModel from "../../../models/thirdparty/ThirdPartyServiceModel";
import ThirdPartyServiceForm, {ThirdPartyServiceFormBody} from "../ThirdPartyServiceForm";
import {useTranslation} from "react-i18next";
import HTMLTextInput from "../../common/HTMLTextInput/HTMLTextInput";
import Collapsable from "../../common/Collapsable/Collapsable";

const initialState = {
    type: ThirdPartyServiceModel.Type.LINK,
    serviceName: '',
    enabled: true,
    description: '',
    whitelistedCertFingerprints: [],

    url: '',

    authenticationScope: ThirdPartyServiceModel.AuthenticationScope.SERVICE,
    authenticationMethod: ThirdPartyServiceModel.AuthenticationMethod.NONE
};

const allowedAuthenticationMethods = [
    ThirdPartyServiceModel.AuthenticationMethod.NONE
];
const allowedAuthenticationScopes = [
    ThirdPartyServiceModel.AuthenticationScope.SERVICE
];

function LinkServiceForm() {
    return (
        <ThirdPartyServiceForm initialState={initialState} FormBody={LinkServiceFormBody}/>
    )
}

export function LinkServiceFormBody(props) {
    return (
        <ThirdPartyServiceFormBody {...props} allowedAuthenticationMethods={allowedAuthenticationMethods}
            allowedAuthenticationScopes={allowedAuthenticationScopes} FormBody={FormBody}/>
    )
}

function FormBody(props) {
    const {t} = useTranslation(['thirdPartyService', 'common']);
    const {
        thirdPartyService,

        inputHandler,
        isDisabled
    } = props;

    return (
        <Collapsable label={t('thirdPartyService:label.settings')} isDisabled={isDisabled}>
            <div className="display-input">
                <HTMLTextInput label={t('thirdPartyService:label.url')} name={'url'} value={thirdPartyService.url}
                    onChange={inputHandler} isDisabled={isDisabled} isRequired/>
            </div>
        </Collapsable>
    );
}

export default LinkServiceForm;
